import { styled } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import { selectFuseCurrentSettings } from 'app/store/fuse/settingsSlice.js';

const Root = styled('div')(({ theme }) => ({
  '& > .logo-icon': {
    transition: theme.transitions.create(['width', 'height'], {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.easeInOut,
    }),
  },
  '& > .badge': {
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.easeInOut,
    }),
  },
}));

const LicenseeVaultLogo = () => {
  const settings = useSelector(selectFuseCurrentSettings);
  return (
    <>
      {settings.licenseeVaultLogo && (
        <Root className='flex items-center'>
          <img className='logo-icon' width={150} src={settings.licenseeVaultLogo} alt='logo' />
        </Root>
      )}
    </>
  );
};

export default LicenseeVaultLogo;
